<template>
  <v-toolbar tabs app fixed dense prominent :color="color" class="elevation-0">
    <v-toolbar-title>
      {{ title }}
    </v-toolbar-title>
  <v-spacer></v-spacer>    
    <v-btn flat icon @click='logOut'>
      <v-icon>exit_to_app</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "ToolBar",
  props: {
    title: String,
    color: String
  },
  methods: {
    logOut() {
      this.$auth.signOut().then(() => {
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/ToolBar.vue